import React, { useEffect, useCallback, useState, useRef } from "react";
import NotificationAlert from "react-notification-alert";
import { releveAdded, saveFile } from "../../Redux/releveNonReduce";
import { useDispatch } from "react-redux";
import { Alert } from "react-bootstrap";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import jwt_decode from "jwt-decode";

function ReleveInserer({client}) {
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);
  const saveTableCalled = useRef(false);
  const notificationAlertRef = React.useRef(null);
  const notify = (place, msg, type) => {
    var options = {
      place: place,
      message: <div><div>{msg}</div></div>,
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  const dispatch = useDispatch();
  const [extensionFile, setExtensionFile] = useState("");
  const [image, setImage] = useState("");
  const [produitExist, setProduitExist] = useState("");
  const navigate = useHistory();
  const [annee, setAnnee] = useState(new Date().getFullYear());
  const [mois, setMois] = useState(new Date().getMonth() + 1);
  const [isDisabled, setIsDisabled] = useState(0);
  const [uploadFile, setUploadFile] = useState();
  const [numPages, setNumPages] = useState(null);
  const [pdfFile, setPdfFile] = useState("");
  const [image1, setImage1] = useState("");
  const [fileName, setFileName] = useState("");

  const uploadBL = (event) => {
    const element = document.getElementById("table-BL");
    if (element) element.classList.add("hidden");

    const blFile = event.target.files[0];
    if (blFile) {
      const ext = blFile.name.split(".").pop().toLowerCase();
      const allowedExtensions = ["pdf", "jpg", "jpeg", "png", "xls", "xlsx"];

      if (!allowedExtensions.includes(ext)) {
        notify("tr", "Type de fichier non supporté !", "danger");
        return;
      }

      setExtensionFile(ext);
      setImage(URL.createObjectURL(blFile));
      setUploadFile(blFile);

      if (ext === "pdf") {
        onFileChange(event);
      } else if (["jpg", "jpeg", "png"].includes(ext)) {
        cropImg(event);
      } else if (["xls", "xlsx"].includes(ext)) {
        console.log("Fichier Excel sélectionné");
      }
    }
  };

  const cropImg = (e) => {
    e.preventDefault();
    const files = e.target.files;
    const reader = new FileReader();
    reader.onload = () => {
      setImage1(reader.result);
    };
    reader.readAsDataURL(files[0]);
  };

  const onFileChange = (event) => {
    setPdfFile(event.target.files[0]);
  };

  const saveTable = useCallback(
    async (uploadFile, annee, mois,client) => {
      const verif = true;
      document.getElementById("saveBL")?.classList.add("hidden");

      if (!verif) {
        document.getElementById("saveBL")?.classList.remove("hidden");
        notify("tr", "Vérifier vos données!", "danger");
        return;
      }

      if (!uploadFile) {
        notify("tr", "Il faut sélectionner un fichier", "danger");
        return;
      }
      const dataArray = new FormData();
      dataArray.append("file", uploadFile);
      dataArray.append("name", uploadFile.name);
      if (saveTableCalled.current) return;
      saveTableCalled.current = true;
      document.getElementById("saveBL")?.classList.add("hidden");

      dispatch(saveFile(dataArray)).then((res) => {
        const filename = res.payload.filename;

        dispatch(
          releveAdded({
            annee: annee,
            mois: mois,
            file: filename,
            namefile: uploadFile.name,
            client
          })
        ).then((res2) => {
          if (res2.payload === true) {
            notify("tr", "Insertion avec succès", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1300);
          } else {
            saveTableCalled.current = false;
            notify("tr", "Relevé a déjà été ajouté", "danger");
          }
        });
      });
    },
    [dispatch, fileName, isDisabled]
  );

  return (
    <>
      <Container fluid className="responsive-BL table-dynamique">
        {produitExist !== "" && <Alert variant="danger">{produitExist}</Alert>}

        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={() => {
                navigate.push(client+"/listereleveinserer");
              }}
            >
              <span className="btn-label">
                <i className="fas fa-list"></i>
              </span>
              Retour à la liste
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">Relevé grossiste</Card.Title>
              </Card.Header>
              <Card.Body>
                <div className="text-center">
                  <Form.Group>
                    <Form.Control
                      id="test"
                      name="file"
                      type="file"
                      accept=".pdf,.jpg,.jpeg,.png,.xls,.xlsx"
                      onChange={(e) => uploadBL(e)}
                    />
                  </Form.Group>

                  {uploadFile && (
                    <div className="mt-3 text-info">
                      Fichier sélectionné : <strong>{uploadFile.name}</strong>
                    </div>
                  )}

                  <br />

                  <Button
                    id="saveBL"
                    className="btn-wd btn-outline mr-1 float-right"
                    type="button"
                    variant="info"
                    onClick={() => saveTable(uploadFile, annee, mois,client)}
                  >
                    <span className="btn-label">
                      <i className="fas fa-check"></i>
                    </span>
                    Enregistrer
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ReleveInserer;
